<div class="balao-aviso" [style.width]="largura" role="note" [attr.aria-label]="texto">
  <p class="balao-texto">{{ texto }}</p>
</div>
